import { StyleSheet } from 'aphrodite';
import theme from '../../styles/theme';

const profileNameStyles = StyleSheet.create({
  container: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
  },
  nameAndProfileGroup: {
    display: 'flex',
    width: '100%',
  },
  iconContainer: {
    display: 'flex',
    width: '42px',
    minWidth: '42px'
  },
  iconContainerSmall: {
    display: 'flex',
    width: '36px',
    minWidth: '36px'
  },
  tagline: {
    fontSize: '14px',
  },
  timeline: {
    fontSize: '14px',
    color: theme.colour.grey,
    textAlign: 'right',
    width: '100px'
  },
});

export default profileNameStyles;
